import React from 'react';
import { WrapperSeamless } from '../../../layout-components';
import Table from '../../../components/tables/table';
import { Button } from '@material-ui/core';
import { useGetList, usePutData } from '../../../hooks';
import { Link } from 'react-router-dom';
import * as Api from '../../../service';
import useStore from '../../../context';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import {useTranslation} from "../../../localization/translation";

const query = {
  limit: 0,
  sort: 'order',
  order: 'asc'
};

export default function List() {
  const { setRemove, language } = useStore();
  const translation = useTranslation();
  const [items, total, refresh, setItems] = useGetList(
    Api.faq.getAll,
    query
  );
  const orderCallback = usePutData(Api.faq.sort, refresh);

  const rows = items?.map((item) => (
    <>
      <td className="text-left">
        <div className="font-size-sm">{item[`question_${language}`]}</div>
      </td>
      <td className="text-right actions_filed">
        <Link to={`/home/faq/create/${item.id}`}>
          <Button className="btn-neutral-first mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center">
            <EditIcon color="primary" />
          </Button>
        </Link>

        <Button
          onClick={() =>
            setRemove(() => () =>
              Api.faq.delete(item.id).then(refresh)
            )
          }
          className="btn-neutral-danger mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center">
          <DeleteIcon color="error" />
        </Button>
      </td>
    </>
  ));

  return (
    <WrapperSeamless>
      <Table
        title={translation.create}
        items={items}
        setItems={setItems}
        total={total}
        titles
        rows={rows}
        orderCallback={orderCallback}
        createLink="home/faq/create"
      />
    </WrapperSeamless>
  );
}
